































































import { Component, Vue, Prop } from "vue-property-decorator";
import {
  ShujuquanxianList,
  ChangeShujuquanxian,
} from "@/request/yonghuquanxian";
import MainHeader from "../../main/components/main-header/main-header.vue";
import NavLeft from "../components/nav-left.vue";
@Component({
  components: {
    MainHeader,
    NavLeft,
  },
})
export default class Sjqxgl extends Vue {
  private window: any = window;
  private libs: any[] = [];
  /**
   * @description 获取数据权限列表
   */
  private getShujuquanxianList() {
    ShujuquanxianList(this).then((data: any) => {
      this.libs = data;
    });
  }
  /**
   * @description 库改变
   */
  private changeLib(e, item) {
    const params: any = {
      project_id: item["project_id"],
      权限: e,
    };
    ChangeShujuquanxian(this, params).then((data: any) => {
      this.$message.success("修改成功");
      this.getShujuquanxianList();
    });
  }
  /**
   * @description 初始化
   */
  private mounted() {
    this.getShujuquanxianList();
  }
}
